module.exports = __webpack_public_path__ + "img/II-29.3e53c056.svg";